import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllStatusOrderUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllStatusOrder/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllStatusOrderUser = data;

    // console.log('!!!!!-------------------- Сервер вернул данные по статусам заказов - ',data);


    return AllStatusOrderUser;
};


const setActiveStatusOrder = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setStatusOrderActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllStatusOrderUser = data;

    // console.log('Сервер вернул данные по обновлению статуса StatusOrder  - ',response);


    return AllStatusOrderUser;
};



const setDeletedStatusOrder = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setStatusOrderDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllStatusOrderUser = data;

    // console.log('Сервер вернул данные по обновлению статуса StatusOrder  - ',response);


    return AllStatusOrderUser;
};




const setUpdateStatusOrder = async (dataStatusOrderUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setStatusOrderUpdate/'),{
        dataStatusOrderUpdate
    });
    return response?.data || {};
};


const setSaveNewStatusOrder = async (dataStatusOrderUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewStatusOrder/'),{
        dataStatusOrderUpdate
    });

    return response?.data || {};
};

Mock.onGet('/api/reference/getAllStatusOrder').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllStatusOrderUser = await getAllStatusOrderUser();

    // if (!AllStatusOrderUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllStatusOrderUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStatusOrderUser,
    ]


})


Mock.onPost('/api/reference/setActiveStatusOrder').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllStatusOrderUser = await setActiveStatusOrder(id,val);

    // if (!AllStatusOrderUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllStatusOrderUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStatusOrderUser,
    ]


})

Mock.onPost('/api/reference/setDeletedStatusOrder').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllStatusOrderUser = await setDeletedStatusOrder(id,val);

    // if (!AllStatusOrderUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllStatusOrderUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStatusOrderUser,
    ]


})


Mock.onPost('/api/reference/setUpdateStatusOrder').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataStatusOrderUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const response = await setUpdateStatusOrder(dataStatusOrderUpdate);

    // console.log('Серовер вернул данные ',AllStatusOrderUser);

    // if (!refereStatusOrder) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (response?.error || String(response?.result || '').toLowerCase() === 'error') {
        return [400, { message: response?.errorInfo || response?.message || 'Не удалось сохранить статус' }]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        response?.data || [],
    ]


})


Mock.onPost('/api/reference/setSaveNewStatusOrder').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataStatusOrderUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const response = await setSaveNewStatusOrder(dataStatusOrderUpdate);

    // console.log('Серовер вернул данные ',AllStatusOrderUser);

    // if (!refereStatusOrder) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (response?.error || String(response?.result || '').toLowerCase() === 'error') {
        return [400, { message: response?.errorInfo || response?.message || 'Не удалось создать статус' }]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        response?.data || [],
    ]
})
